import type { PositionBucket, QueryLengthBucket } from '@packages/types';
import { parseOmniboxItemId } from './omnibox.items';

/** The closed bucket for a query's length; the text itself never leaves the browser. */
export function queryLengthBucket(length: number): QueryLengthBucket {
  if (length <= 0) return '0';
  if (length <= 2) return '1-2';
  if (length <= 5) return '3-5';
  if (length <= 10) return '6-10';
  if (length <= 20) return '11-20';
  return '21+';
}

/** The bucket for a 1-based rank from `rankInGroup`. */
export function positionBucket(position: number): PositionBucket {
  if (position <= 1) return '1';
  if (position <= 3) return '2-3';
  if (position <= 5) return '4-5';
  return '6+';
}

const isDestinationRow = (id: string) => parseOmniboxItemId(id)?.kind === 'destination';

/**
 * A row's 1-based rank among the rows of its own group: record rows for a record, "Go to" rows
 * for a destination. Ranking records apart keeps a record's rank from moving when "Go to" rows
 * lead the list. The pinned Ask row is not in `itemIds`, so it is in neither group.
 */
export function rankInGroup(itemIds: readonly string[], id: string): number {
  const destination = isDestinationRow(id);
  return itemIds.filter((itemId) => isDestinationRow(itemId) === destination).indexOf(id) + 1;
}
